<div class="article-tpye-base-article-definition-list">
    <sc-padding>
        <table class="table">
            <tr *ngFor="let attribute of definition?.attributes; let i = index">
                <td class="text-selection">{{i+1}}</td>
                <td class="text-selection"><app-dictionary-entry-label [model]="attribute?.articleTypeAttribute?.name"></app-dictionary-entry-label></td>
            </tr>
        </table>
    </sc-padding>
</div>
